import { Alert, Button, Space, notification } from "antd";
import CustomIcon from "components/shared/CustomIcon";
import util from "config/utils";
import { useTranslation } from "react-i18next";

const LinkForShare = (props: { name: string, link: string, onBack: () => void }) => {
    const { t } = useTranslation();
    const handleShare = () => {
        if ("navigator" in window) {
            window.navigator.share({
                title: t("paymentLinkForX", { x: props.name }) ?? "",
                text: props.link
            })
        }
    }
    const handleCopy = () => {
        util.copyToClipboard(props.link);
        notification.info({
            message: t("copiedToClipboard")
        })
    }
    return <div
        className='link-for-share'
        id='link-for-share'
        style={{
            width: "100%",
            margin: "100px 0"
        }}
    >
        <Alert
            message={t("paymentLinkForX", { x: props.name })}
            description={props.link}
            type="info"
            showIcon
            closeIcon={  <Button size="small" type="ghost">
            <CustomIcon name="IoArrowUndoOutline" size={24} />
        </Button>}
            action={
                <Space direction="horizontal">
                    <Button size="small" type="ghost" onClick={handleCopy}>
                        <CustomIcon name="IoCopyOutline" size={24} />
                    </Button>
                    <Button size="small" type="ghost" onClick={handleShare}>
                        <CustomIcon name="IoShareSocialOutline" size={24} />
                    </Button>
                </Space>

            }
            closable
            onClose={props.onBack}
        />
    </div>;
}
export default LinkForShare;